import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

const CustomLinkEmbed = ({ href, title, description, image }: any) => {
    const { token } = useAntDesignTheme();

    return (
        <div style={{ border: `1px solid ${token.colorBgBase}`, padding: '1rem', borderRadius: token.borderRadius }}>
            <a href={href} target='_blank' rel='noopener noreferrer'>
                <div style={{ marginBottom: '5px' }}>
                    {image && <img src={image} alt={title} style={{ maxWidth: '100%', height: 'auto' }} />}
                </div>
                <div style={{ fontWeight: 'bold' }}>{title}</div>
                {description && <div>{description}</div>}
            </a>
        </div>
    );
};

export default CustomLinkEmbed;
